import { tv } from 'tailwind-variants';

const imageStyles = tv({
    slots: {
        imageContainer: "iris:overflow-hidden",
        image: `
      iris:h-full
      iris:w-full
      iris:object-cover
    `,
    },
    variants: {
        imagePosition: {
            top: {
                image: "iris:rounded-t-(--comp-size-radius-card) iris:align-bottom",
            },
            left: {
                image: "iris:h-full iris:rounded-l-(--comp-size-radius-card)",
            },
            full: {
                imageContainer: "iris:rounded-(--comp-size-radius-card)",
                image: "iris:h-full iris:rounded-(--comp-size-radius-card)",
            },
        },
    },
});

export { imageStyles as default };
